//
//
//
//
//
//
//
//

const consola = require('consola'); consola.level = process.env.CONSOLA_LEVEL;;
import { mapGetters, mapMutations, mapActions } from 'vuex'
// import rafLoop from 'raf-loop'
import Intersect from '~/components/vue-intersect'

export default {
	name: 'scroll-observer',
	components:
	{
		Intersect
	},

	props:
	{
		active:
		{
			type: Boolean,
			default: true,
		},

		threshold:
		{
			type: Array,
			// default: () => [],
		},

		root:
		{
			type: Object,
			// default: null,
		},

		rootMargin:
		{
			type: String,
			// default: '',
		},

		calcScrollY:
		{
			type: Boolean,
			default: false,
		},

		calcVisibility:
		{
			type: Boolean,
			default: false,
		},

		calcScreenY:
		{
			type: Boolean,
			default: false,
		},

		updateOnScrollOnly:
		{
			type: Boolean,
			default: false
		}
	},

	data()
	{
		return {
			isIntersecting: false,
			scrollPercentY: 0,
			visiblePercent: 0,
			screenPercentY: 0,
			prevScrollY: -9999
		}
	},

	watch:
	{
		active(newVal)
		{
			if (!newVal)
			{
				this.$raf.removeListener('tick', this.onUpdate)
			}
		}
	},

	computed:
	{
		...mapGetters(['scrollTop']),
	},

	mounted()
	{
		const self = this;

		consola.debug('scroll-observer mounted, updateOnScrollOnly: ', this.updateOnScrollOnly, this.$vnode)

		// this.raf = null;
		// this.raf = rafLoop(function(dt)
		// {
		// 	self.onUpdate(dt);
		// });
		// this.$raf.addListener('tick', this.onUpdate)

		this.$nextTick(() =>
		{
			this.onEnter()

			if (this.$slots.default && this.$slots.default.length > 1)
			{
				consola.debug('[scroll-observer] You may only wrap one element in a <scroll-observer> component.')
				return;
			}
			else
				if (!this.$slots.default || this.$slots.default.length < 1)
				{
					consola.debug('[scroll-observer] You must have one child inside a <scroll-observer> component.')
					return
				}
		})
	},

	beforeDestroy()
	{
		// this.raf && this.raf.stop();
		// this.raf = null;
		this.$raf.removeListener('tick', this.onUpdate)
		// this.$emit('destroy');
		if (this.$eventBus) this.$eventBus.$emit('scroll-observer:destroy', this);
	},


	// render(createElement)
	// {
	// 	if (this.active)
	// 	{
	// 		return createElement('intersect',
	// 					{
	// 						props:
	// 						{
	// 							threshold: this.threshold,
	// 							root: this.root,
	// 							rootMargin: this.rootMargin,
	// 						},
	// 						on:
	// 						{
	// 							enter: this.onEnter,
	// 							leave: this.onLeave,
	// 							change: this.onChange,
	// 						},
	// 						scopedSlots:
	// 						{
	// 							scrollPercentY: this.scrollPercentY,
	// 							visiblePercent: this.visiblePercent,
	// 							screenPercentY: this.screenPercentY
	// 						},
	// 					},
	// 					[this.$scopedSlots.default]
	// 					// ({
	// 					// 	scrollPercentY: this.scrollPercentY,
	// 					// 	visiblePercent: this.visiblePercent,
	// 					// 	screenPercentY: this.screenPercentY
	// 					// })
	// 		)
	// 	}
	// 	else
	// 		return createElement(this.$scopedSlots.default)
	// },


	methods:
	{
		onEnter(event)
		{
			//- @enter and @leave events from <intersect> are not reliable, do NOT use them
			// consola.debug('onEnter', event, this)
			if (!this.active) return;
			// consola.debug('ScrollObserver enter:', event)
			// this.raf && this.raf.start();
			this.$raf.removeListener('tick', this.onUpdate)
			this.$raf.addListener('tick', this.onUpdate)
			this.$emit('enter', event);
			// consola.debug('onEnter')
		},

		onLeave(event)
		{
			//- @enter and @leave events from <intersect> are not reliable, do NOT use them
			// consola.debug('onLeave', event, this)
			if (!this.active) return;
			// consola.debug('ScrollObserver leave:', event)
			// this.raf && this.raf.stop();
			this.$raf.removeListener('tick', this.onUpdate)
			this.$emit('leave', event);
			// consola.debug('onLeave')
		},

		onChange(entries)
		{
			// consola.debug('onChange', entries, this)
			// consola.debug('scroll observer onChange', event)
			if (!this.active) return;
			this.$emit('change', entries);
			if (entries)
			{
				if (entries[0].isIntersecting && this.isIntersecting==false )
				{
					this.isIntersecting = true;
					this.onEnter(entries)
				}
				if (entries[0].isIntersecting==false && this.isIntersecting==true )
				{
					this.isIntersecting = false;
					this.onLeave(entries)
				}
			}
		},

		onUpdate(dt)
		{
			if (!this.active)
			{
				this.$raf.removeListener('tick', this.onUpdate);
				return;
			}
			// let y = 0;
			// if (this.$slots.default)
			// {
			// 	let box = this.$slots.default[0].elm.getBoundingClientRect();
			// 	if (box)
			// 	{
			// 		y = box.top;
			// 	}
			// }
			// const scrollY = y;// + this.scrollTop;
			// consola.debug('onUpdate')
			const scrollY = (window.scrollY || document.body.scrollTop) + this.scrollTop;
			if (this.prevScrollY != scrollY)
			{
				// consola.debug('scroll-observer onUpdate scrollY: ', scrollY)
				let box = null;
				if (this.calcScrollY)
				{
					box = JSON.parse(JSON.stringify( this.$el.getBoundingClientRect() ));
					box.top -= this.scrollTop;
					box.bottom -= this.scrollTop;
					const height = window.innerHeight + box.height;
					let y = box.top - scrollY;
					this.scrollPercentY = y / height;
				}
				if (this.calcVisibility)
				{
					if (!box)
					{
						box = box || JSON.parse(JSON.stringify( this.$el.getBoundingClientRect() ));
						box.top -= this.scrollTop;
						box.bottom -= this.scrollTop;
					}

					let height = box.height;
					if (box.top < 0)	height += box.top;
					if (window.innerHeight > box.bottom)	height -= (box.bottom - window.innerHeight);
					if (box.top > window.innerHeight)	height = 0;
					if (box.bottom < 0)	height = 0;
					this.visiblePercent = height / (box.height || 1);
				}
				if (this.calcScreenY)
				{
					if (!box)
					{
						box = box || JSON.parse(JSON.stringify( this.$el.getBoundingClientRect() ));
						box.top -= this.scrollTop;
						box.bottom -= this.scrollTop;
					}
					this.screenPercentY = box.top / window.innerHeight;
				}
				this.prevScrollY = scrollY;
				this.$emit('tick')
			}
			else if (!this.updateOnScrollOnly)
				this.$emit('tick')
		},
	},

}
